import { useAnalytics, TRACK_EVENTS } from '@/composables/analytics'

export type ExperimentViewedAssignment = {
  experiment?: string
  featureFlag?: string
  variation?: unknown
  subject?: string
  subjectAttributes?: { subject_type?: string }
  timestamp?: string
}

export function experimentViewed (assignment: ExperimentViewedAssignment | null | undefined): void {
  if (!assignment) return

  const analytics = useAnalytics()

  analytics
    .track(TRACK_EVENTS.EXPERIMENT_VIEWED,
      {
        experiment_id: assignment.experiment,
        experiment_name: assignment.featureFlag,
        variation_id: String(assignment.variation),
        subject_id: assignment.subject,
        subject_type: assignment.subjectAttributes?.subject_type,
        assignment_timestamp: assignment.timestamp,
      },
      { eventVersion: 1 }
    )
}
